require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/legacy/floors/breadcrumb/main-breadcrumbs.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/legacy/floors/breadcrumb/main-breadcrumbs.legacy.js
// module id = 680
// module chunks = 31